export const jascaydAudience = [
  {
    label: 'Pulmonologists',
    line: 'The core specialists for the clinical conversation.',
  },
  {
    label: 'Rheumatologists',
    line: 'A key adjacent audience for the same patients.',
  },
]

export const jascaydMarkets = [
  { name: 'Australia', inScope: true },
  { name: 'New Zealand', inScope: true },
  { name: 'South Korea', inScope: true },
  { name: 'Southeast Asia', inScope: true },
  { name: 'China', inScope: false },
  { name: 'Japan', inScope: false },
]

export const jascaydConcept = {
  name: 'FIBRONEER-IPF Evidence Explorer',
  url: 'https://fibroneer-ipf.snakker.io',
  lead: 'A short interactive Snak that asks HCPs to estimate the Phase 3 FVC result before revealing it — turning a key study finding into a moment they actively take part in.',
  flow: ['Hook', 'Study context', 'Your estimate', 'Result', 'Population', 'Mechanism', 'Summary'],
}

export const jascaydSteps = [
  {
    number: '01',
    title: 'Select a starting point',
    text: 'Together, we pick an upcoming campaign or approved content suitable for a pilot.',
  },
  {
    number: '02',
    title: 'Shape the journey',
    text: 'Lead with a brief, relevant Snak. Offer interested HCPs a deeper follow-up — earn attention first.',
  },
  {
    number: '03',
    title: 'Guide with interaction',
    text: 'A short quiz or poll captures what HCPs think — not just clicks and viewing time.',
  },
  {
    number: '04',
    title: 'Coordinate delivery',
    text: 'Confirm markets, channels, hosting and any agency involvement. Tailored per market.',
  },
  {
    number: '05',
    title: 'Review and refine',
    text: 'Agree success measures upfront, then use engagement and response data to adjust.',
  },
]

export const jascaydPilotMonths = 3

export const jascaydCampaignContent = {
  title: 'Campaign content',
  billing: 'One-off',
  price: 10000,
  includes: [
    'Campaign strategy',
    'Storyboarding',
    'Snak creation',
    '2× MLR revision rounds',
  ],
}

export const jascaydCampaignManagement = {
  title: 'Pilot campaign management',
  billing: 'Per month',
  monthly: 1000,
  includes: [
    'Campaign management',
    'Analysis of engagement and response data',
    'Recommendations for channel improvements',
    'Recommendations for content improvements',
  ],
}

export const jascaydPilotTotal =
  jascaydCampaignContent.price +
  jascaydCampaignManagement.monthly * jascaydPilotMonths

export const jascaydPilotValue = [
  'Earn specialist attention',
  'Capture what HCPs think',
  'Prove it before you scale',
]
